import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
    TextField
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Raisepayment = ({ openDialog, setOpenDialog, setgetOrder, selectedOrder }) => {
    //handle close
    const handleClose = () => {
        setOpenDialog(false);

        //empty the textfilelds
        setPaymentAmount('');
        // setTotalAmount('')
    };


    // Handle raise payment API call
    // const [totalamount, setTotalAmount] = useState('');
    const [paymentamount, setPaymentAmount] = useState('');
    const [loading,setLoading] = useState(false);

    //assign order
    const handleRaisePayment = async (selectedOrder) => {
        if (!paymentamount) {
            toast.error("Please enter all fields.");
            return;
        }
        setLoading(true);
        // Further validation (e.g., numeric and range checks)
        //  if (isNaN(totalamount) || isNaN(paymentamount)) {
        //     toast.error("Both fields must contain valid numbers.");
        //     return;
        // }

        // if (Number(paymentamount) > Number(totalamount)) {
        //     toast.error("Payment Amount cannot exceed the Total Amount.");
        //     return;
        // }
        try {
            const response = await instance.patch('/Order/raisePayment',
                {
                    order_id: selectedOrder._id, // Use `selectedOrder` to access `order_id`
                    // total_amount: totalamount,
                    payment_amount: paymentamount,
                }
            )

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetOrder(true)
                setLoading(false);
            } else {
                toast.error(response.data.message)
                setLoading(false);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
            setLoading(false);
        }
    }


    return (
        <>
            <React.Fragment>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={openDialog}
                    className="admin-admins"
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        Raise Payment for the Order
                        <Typography variant="subtitle1">
                            Enter the payment details for the selected order.
                        </Typography>
                    </DialogTitle>
                    <hr style={{ margin: "5px 0px" }} />
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <section className="add-admin">
                            <Grid container spacing={2}>
                                {/* <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                    <div className="admin-textfiled">
                                        <TextField
                                            placeholder="Enter Total Amount"
                                            label="Total Amount"
                                            type="text"
                                            fullWidth
                                            required
                                            value={totalamount}
                                            onChange={(e) => setTotalAmount(e.target.value)}
                                        />
                                    </div>
                                </Grid> */}
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                    <div className="admin-textfiled">
                                        <TextField
                                            placeholder="Enter Payment Amount"
                                            label="Payment Amount"
                                            type="text"
                                            fullWidth
                                            required
                                            value={paymentamount}
                                            onChange={(e) => setPaymentAmount(e.target.value)}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </section>
                        {/* <hr style={{ margin: "15px 0px" }} />
                    <section className="add-order">
                        <div className='add-employee-title'>
                            <Typography>Previous Bookings</Typography>
                        </div>
                        <CommonTable columns={data.columns} rows={data.rows} />
                    </section> */}
                    </DialogContent>
                    <DialogActions>
                        <Button className="cancel-btn" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button className="add-btn" onClick={() => handleRaisePayment(selectedOrder)} disabled={loading}>Raise Payment</Button>
                    </DialogActions>
                </BootstrapDialog>
            </React.Fragment>

        </>
    )
}

export default Raisepayment;

